import { render, staticRenderFns } from "./nurse.vue?vue&type=template&id=cdc1a9e0&scoped=true"
import script from "./nurse.vue?vue&type=script&lang=ts"
export * from "./nurse.vue?vue&type=script&lang=ts"
import style0 from "./nurse.vue?vue&type=style&index=0&id=cdc1a9e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc1a9e0",
  null
  
)

export default component.exports